import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'Core/components';
import { showToast } from 'Core/redux/toast/slice';
import {
  QUALITY_STATUSES,
  QUALITY_STATUSES_COLORS,
  QUALITY_STATUS_ID,
} from 'Core/constants/constants';
import CustomPropTypes from 'Core/prop-types';
import {
  approveRejectQualityApproval,
  extendQualityApproval,
  fetchQualityApprovalsWithFilters,
  requestEvidenceQualityApproval,
} from './store/slice';
import { AppModal } from '../components/app-modals';
import { useTransformOptions } from 'Core/hooks';
import QualityCategory from './quality-category';
import { selectParts } from 'Core/redux/part/selectors';
import CustomAccordion from '../../core/components/accordion/accordion';
import { selectFilteredQualityData, qualityApprovalDataSortKey } from './store/selectors';
import { actions as qualityApprovalActions } from './store/slice';
import QualityApprovalSearch from './qualityapproval-search';
import { HardDrive } from 'react-feather';
import { Alert } from 'react-bootstrap';
import { format } from 'date-fns';

const { setQualityApprovalSortKey } = qualityApprovalActions;

const getLoggedInUserForQualityAction = () =>
  localStorage.getItem('UserName') ||
  localStorage.getItem('userName') ||
  localStorage.getItem('UserId') ||
  '';

const initData = [
  {
    id: 0,
    partId: 0,
    type: '',
  },
];

const QualityApprovalAddEdit = ({
  showModal,
  selectedPart,
  modalData,
  onCloseModal,
  onChanges,
}) => {
  const qualityApprovalData = useSelector(selectFilteredQualityData);
  const formatDateTime = value => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return format(date, 'dd-MMM-yyyy HH:mm');
  };

  // const qualityApprovalData = modalData;
  const [formData, setFormData] = useState(qualityApprovalData ? qualityApprovalData : initData);

  const sortKey = useSelector(qualityApprovalDataSortKey);

  const [dataSortKey, setDataSortKey] = useState(sortKey);

  useEffect(() => {
    setFormData(qualityApprovalData);
  }, [qualityApprovalData]);

  useEffect(() => {
    setDataSortKey(sortKey);
  }, [sortKey]);
  const parts = useSelector(selectParts);
  const partsOptions = useTransformOptions(parts, 'id', 'partNumber', '', 'Select Part');

  const dispatch = useDispatch();
  const isEditMode = Boolean(qualityApprovalData?.id);

  const handleSort = val => {
    // const sortKey = val;
    setDataSortKey(val);
    dispatch(setQualityApprovalSortKey(val));
  };

  const oldandlatestvalue = [
    { value: 'categoryName', label: 'Sort By Category' },
    { value: 'statusId', label: 'Sort By Status' },
  ];

  const onChangesTools = (action, { requestId, comments }) => {
    if (!comments || !comments.trim()) {
      updateField(requestId, 'isError', true, true);
      dispatch(
        showToast({
          message: 'Please fill the comments field',
          type: 'danger',
        }),
      );
      return;
    }

    if (action) {
      const loginUser = getLoggedInUserForQualityAction();
      const payload = {
        requestId,
        statusId: action,
        comments,
        userId: loginUser,
        UserId: loginUser,
        statusChangedBy: loginUser,
        statusChangedDate: new Date(),
        approvedBy: loginUser,
        approvedDate: new Date(),
      };
      dispatch(approveRejectQualityApproval(payload))
        .unwrap()
        .then(() => {
          setFormData(prevData =>
            prevData.map(item =>
              item.requestId === requestId
                ? {
                    ...item,
                    statusId: action,
                    comments,
                    isError: false,
                  }
                : item,
            ),
          );
        })
        .catch(() => {
          /* failure handled by toast */
        });
    }
  };

  const onRequestEvidence = ({
    requestId,
    partId,
    partNumber,
    workTicket,
    comments,
  }) => {
    if (!comments || !comments.trim()) {
      updateField(requestId, 'isError', true, true);
      dispatch(
        showToast({
          message: 'Please fill the comments field',
          type: 'danger',
        }),
      );
      return;
    }

    const loginUser = getLoggedInUserForQualityAction();
    const payload = {
      requestId,
      partId: partId ?? selectedPart?.id,
      partNumber: partNumber || selectedPart?.partNumber || '',
      workTicket: workTicket || '',
      comments,
      requestedBy: loginUser,
      requestedDate: new Date().toISOString(),
    };

    dispatch(requestEvidenceQualityApproval(payload))
      .unwrap()
      .then(response => {
        setFormData(prevData =>
          prevData.map(item =>
            item.requestId === requestId
              ? {
                  ...item,
                  statusId: response?.statusId || QUALITY_STATUS_ID.EVIDENCE_REQUESTED,
                  comments,
                  isError: false,
                  statusChangedBy: loginUser,
                  statusChangedDate: response?.requestedDate || new Date().toISOString(),
                }
              : item,
          ),
        );
      })
      .catch(() => {
        /* failure handled by toast */
      });
  };

  const updateField = (requestId, fieldName, value, overrideError = false) => {
    setFormData(prevData =>
      prevData.map(qaObj => {
        if (qaObj.requestId !== requestId) {
          return qaObj;
        }

        if (fieldName === 'comments') {
          const hasValue = value && value.trim();
          return {
            ...qaObj,
            comments: value,
            isError: !hasValue,
          };
        }

        if (fieldName === 'isError' && overrideError) {
          return {
            ...qaObj,
            isError: value,
          };
        }

        return {
          ...qaObj,
          [fieldName]: value,
        };
      }),
    );
  };

  const onCommentUpdate = (requestId, comments) => {
    updateField(requestId, 'comments', comments);
  };

  const handleClose = () => {
    dispatch(fetchQualityApprovalsWithFilters());
    onCloseModal();
  };
  const onExtend = () => {
    const payload = {
      ...formData,
      savedAt: new Date().toISOString(),
    };
    dispatch(extendQualityApproval(payload));
  };

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
    if (onChanges && typeof onChanges === 'function') {
      onChanges({
        ...formData,
        [fieldName]: value,
      });
    }
  };

  const inspectionTypes = [
    { value: 'AQL Inspection', label: 'AQL Inspection' },
    { value: 'Release Inspection', label: 'Release Inspection' },
  ];

  const statusName = statusId => {
    switch (statusId) {
      case QUALITY_STATUS_ID.CREATED:
        return QUALITY_STATUSES.CREATED;
      case QUALITY_STATUS_ID.APPROVED:
        return QUALITY_STATUSES.APPROVED;
      case QUALITY_STATUS_ID.REJECTED:
        return QUALITY_STATUSES.REJECTED;
      case QUALITY_STATUS_ID.CONDITIONALLY_APPROVED:
        return QUALITY_STATUSES.CONDITIONALLY_APPROVED;
      case QUALITY_STATUS_ID.EVIDENCE_REQUESTED:
        return QUALITY_STATUSES.EVIDENCE_REQUESTED;
      default:
        return '';
    }
  };

  const statusColor = statusId => {
    switch (statusId) {
      case QUALITY_STATUS_ID.CREATED:
        return QUALITY_STATUSES_COLORS.WARNING;
      case QUALITY_STATUS_ID.APPROVED:
        return QUALITY_STATUSES_COLORS.SUCCESS;
      case QUALITY_STATUS_ID.REJECTED:
        return QUALITY_STATUSES_COLORS.DANGER;
      case QUALITY_STATUS_ID.CONDITIONALLY_APPROVED:
        return QUALITY_STATUSES_COLORS.INFO;
      case QUALITY_STATUS_ID.EVIDENCE_REQUESTED:
        return QUALITY_STATUSES_COLORS.WARNING;
      default:
        return QUALITY_STATUSES_COLORS.SECONDARY;
    }
  };

  const body = () => {
    return (
      <div className="row">
        <div className="col-12 d-flex flex-row mb-3">
          <QualityApprovalSearch data={true} />
          <Select
            className="img-select stattusSelect"
            defaultValue={dataSortKey}
            style={{ width: '300px' }}
            classNamePrefix="react-select"
            options={oldandlatestvalue}
            onChange={handleSort}
            value={dataSortKey}
            placeholder="Sort By"
          />
        </div>
        <div className="col-12">
          {formData && formData.length > 0 && (
            <CustomAccordion>
              {(formData || []).map((category, index) => (
                <QualityCategory
                  key={category.requestId}
                  title={
                    <>
                      <div className="row w-100">
                        <div className='col-6 d-flex flex-column flex-md-row align-items-xs-center"'>
                          <h5>{`Request ${index + 1}:  `}</h5>&nbsp;&nbsp;&nbsp;
                          <label>{`  ${category.categoryName}`}</label>
                        </div>
                        <div className="col-6 d-flex align-items-start justify-content-end pe-md-5 mt-3 mt-md-0">
                          <div className="d-flex flex-column align-items-end text-end">
                            <span className={`label p-1 ${statusColor(category.statusId)} rounded mb-1`}>
                              {statusName(category.statusId)}
                            </span>
                            {category.statusId === QUALITY_STATUS_ID.APPROVED && (
                              <>
                                <small className="text-muted">
                                  Approved By: {category.statusChangedBy || '-'}
                                </small>
                                <small className="text-muted">
                                  Approved Date: {formatDateTime(category.statusChangedDate)}
                                </small>
                              </>
                            )}
                            {category.statusId === QUALITY_STATUS_ID.EVIDENCE_REQUESTED && (
                              <>
                                <small className="text-muted">
                                  Evidence Requested By: {category.statusChangedBy || '-'}
                                </small>
                                <small className="text-muted">
                                  Evidence Requested Date:{' '}
                                  {formatDateTime(category.statusChangedDate)}
                                </small>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  data={category}
                  onAction={onChangesTools}
                  onRequestEvidence={onRequestEvidence}
                  onCommentUpdate={onCommentUpdate}
                ></QualityCategory>
              ))}
            </CustomAccordion>
          )}
          {(!formData || formData.length == 0) && (
            <div className="no-data-container">
              <Alert
                className="h-50px mb-0 w-50 p-3 d-flex justify-content-center align-items-center"
                key={'danger'}
                variant={'danger'}
              >
                <span className="me-3">
                  <HardDrive size={24} />
                </span>{' '}
                <label>No data</label>
              </Alert>
            </div>
          )}
        </div>
      </div>
    );
  };

  const valid = () => {
    if (formData?.length === 0) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const footer = () => {
    return null;
  };

  return (
    <Modal
      id="qualityapproval-modal"
      show={showModal}
      headerStyle={{ minHeight: '85px' }}
      size="xl"
      title={
        <div className="d-flex flex-row">
          <h4>{`Part ID:  ${selectedPart?.id ?? ''}`}</h4>
          <h4 className="ms-5">{`Part Number:  ${selectedPart?.partNumber ?? ''}`}</h4>
        </div>
      }
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

QualityApprovalAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.arrayOf(PropTypes.shape(CustomPropTypes.QualityApproval)),
  onCloseModal: PropTypes.func,
  onChanges: PropTypes.func,
  selectedPart: PropTypes.object,
};

export default AppModal(QualityApprovalAddEdit);
